// languages-i18n.js
export default [
  {
    wdQid: 'Q13955',
    wikimediaCode: 'ar',
    i18nCode: 'ar',
    labelEN: 'Arabic',
    labelNative: 'اللُّغَة العَرَبِيّة',
    direction: 'rtl',
  } /*
  {
    "wdQid": "Q29507", 
    "wikimediaCode": "ast",
    "i18nCode": "ast",
    "labelEN": "Asturian",
    "labelNative": "Asturianu",
    "direction": "ltr"
  }, */,
  {
    wdQid: 'Q158',
    wikimediaCode: 'az',
    i18nCode: 'az',
    labelEN: 'Azerbaijani',
    labelNative: 'Azərbaycanca',
    direction: 'ltr',
  } /*
  {
    "wdQid": "Q13389",
    "wikimediaCode": "ba",
    "i18nCode": "ba",
    "labelEN": "Bashkir",
    "labelNative": "Башҡорт",
    "direction": "ltr"
  },
  {
    "wdQid": "Q12107", 
    "wikimediaCode": "br",
    "i18nCode": "br",
    "labelEN": "Breton",
    "labelNative": "Brezhoneg",
    "direction": "ltr"
  },
  {
    "wdQid": "Q9610", 
    "wikimediaCode": "bn",
    "i18nCode": "bn",
    "labelEN": "Bengali",
    "labelNative": "বাংলা",
    "direction": "ltr"
  },
  {
    "wdQid": "Q7026",
    "wikimediaCode": "ca",
    "i18nCode": "ca",
    "labelEN": "Catalan",
    "labelNative": "Català",
    "direction": "ltr"
  },
  {
    "wdQid": "Q33350",
    "wikimediaCode": "ce",
    "i18nCode": "ce",
    "labelEN": "Chechen",
    "labelNative": "Noxçiyn mott",
    "direction": "ltr"
  }, */,
  {
    wdQid: 'Q9035',
    wikimediaCode: 'da',
    i18nCode: 'da',
    labelEN: 'Danish',
    labelNative: 'Dansk',
    direction: 'ltr',
  },
  {
    wdQid: 'Q188',
    wikimediaCode: 'de',
    i18nCode: 'de',
    labelEN: 'German',
    labelNative: 'Deutsch',
    direction: 'ltr',
  } /*
  {
    "wdQid": "Q9129",
    "wikimediaCode": "el",
    "i18nCode": "el",
    "labelEN": "Greek",
    "labelNative": "Ελληνικά",
    "direction": "ltr"
  }, */,
  {
    wdQid: 'Q1860',
    wikimediaCode: 'en',
    i18nCode: 'en',
    labelEN: 'English',
    labelNative: 'English',
    direction: 'ltr',
  } /*
  {
    "wdQid": "Q143", 
    "wikimediaCode": "eo",
    "i18nCode": "eo",
    "labelEN": "Esperanto",
    "labelNative": "Esperanto",
    "direction": "ltr"
  }, */,
  {
    wdQid: 'Q1321',
    wikimediaCode: 'es',
    i18nCode: 'es',
    labelEN: 'Spanish',
    labelNative: 'Español',
    direction: 'ltr',
  },
  {
    "wdQid": "Q8748", 
    "wikimediaCode": "eu",
    "i18nCode": "eu",
    "labelEN": "Basque",
    "labelNative": "Euskara",
    "direction": "ltr"
  },/*
  {
    "wdQid": "Q9168",
    "wikimediaCode": "fa",
    "i18nCode": "fa",
    "labelEN": "Persian",
    "labelNative": "فارسی",
    "direction": "rtl"
  },
  {
    "wdQid": "Q1412",
    "wikimediaCode": "fi",
    "i18nCode": "fi",
    "labelEN": "Finnish",
    "labelNative": "Suomi",
    "direction": "ltr"
  }, */
  {
    wdQid: 'Q150',
    wikimediaCode: 'fr',
    i18nCode: 'fr',
    labelEN: 'French',
    labelNative: 'Français',
    direction: 'ltr',
  },
  {
    wdQid: 'Q9142',
    wikimediaCode: 'ga',
    i18nCode: 'ga',
    labelEN: 'Irish',
    labelNative: 'Gaeilge',
    direction: 'ltr',
  },
  {
    wdQid: 'Q9307',
    wikimediaCode: 'gl',
    i18nCode: 'gl',
    labelEN: 'Galician',
    labelNative: 'Galego',
    direction: 'ltr',
  },
  {
    wdQid: 'Q9288',
    wikimediaCode: 'he',
    i18nCode: 'he',
    labelEN: 'Hebrew',
    labelNative: 'עברית',
    direction: 'rtl',
  },
  {
    wdQid: 'Q1568',
    wikimediaCode: 'hi',
    i18nCode: 'hi',
    labelEN: 'Hindi',
    labelNative: 'हिन्दी',
    direction: 'ltr',
  },
  {
    wdQid: 'Q9240',
    wikimediaCode: 'id',
    i18nCode: 'id',
    labelEN: 'Indonesian',
    labelNative: 'Bahasa Indonesia',
    direction: 'ltr',
  },
  {
    wdQid: 'Q35934',
    wikimediaCode: 'ia',
    i18nCode: 'ia',
    labelEN: 'Interlingua',
    labelNative: 'Interlingua',
    direction: 'ltr',
  },
  {
    wdQid: 'Q35224',
    wikimediaCode: 'io',
    i18nCode: 'io',
    labelEN: 'Ido',
    labelNative: 'Ido',
    direction: 'ltr',
  },
  {
    wdQid: 'Q652',
    wikimediaCode: 'it',
    i18nCode: 'it',
    labelEN: 'Italian',
    labelNative: 'Italiano',
    direction: 'ltr',
  },
  {
    wdQid: 'Q5287',
    wikimediaCode: 'ja',
    i18nCode: 'ja',
    labelEN: 'Japanese',
    labelNative: '日本語',
    direction: 'ltr',
  },
  {
    wdQid: 'Q33541',
    wikimediaCode: 'kaa',
    i18nCode: 'kaa',
    labelEN: 'Karakalpak',
    labelNative: 'Qaraqalpaq tili',
    direction: 'ltr',
  },
  {
    wdQid: 'Q9176',
    wikimediaCode: 'ko',
    i18nCode: 'ko',
    labelEN: 'Korean',
    labelNative: '한국어',
    direction: 'ltr',
  },
  {
    wdQid: 'Q36368',
    wikimediaCode: 'ku',
    i18nCode: 'ku-latn',
    labelEN: 'Kurdish',
    labelNative: 'Kurdî',
    direction: 'ltr',
  },
  {
    wdQid: 'Q25289',
    wikimediaCode: 'kw',
    i18nCode: 'kw',
    labelEN: 'Cornish',
    labelNative: 'Kernewek',
    direction: 'ltr',
  },
  {
    wdQid: 'Q27305',
    wikimediaCode: 'lb',
    i18nCode: 'lb',
    labelEN: 'Luxembourgish',
    labelNative: 'Lëtzebuergesch',
    direction: 'ltr',
  },/*
  {
    "wdQid": "Q9083", 
    "wikimediaCode": "lt",
    "i18nCode": "lt",
    "labelEN": "Lithuanian",
    "labelNative": "Lietuvių",
    "direction": "ltr"
  }, */
  {
    wdQid: 'Q9166',
    wikimediaCode: 'mt',
    i18nCode: 'mt',
    labelEN: 'Maltese',
    labelNative: 'Malti',
    direction: 'ltr',
  },
  {
    wdQid: 'Q9296',
    wikimediaCode: 'mk',
    i18nCode: 'mk',
    labelEN: 'Macedonian',
    labelNative: 'Македонски',
    direction: 'ltr',
  } /*
  {
    "wdQid": "Q9237", 
    "wikimediaCode": "ms",
    "i18nCode": "ms",
    "labelEN": "Malay",
    "labelNative": "Bahasa Melayu",
    "direction": "ltr"
  },
  {
    "wdQid": "Q25167", 
    "wikimediaCode": "nb",
    "i18nCode": "nb",
    "labelEN": "Norwegian Bokmål",
    "labelNative": "Norsk bokmål",
    "direction": "ltr"
  },
  {
    "wdQid": "Q33823", 
    "wikimediaCode": "ne",
    "i18nCode": "ne",
    "labelEN": "Nepali",
    "labelNative": "नेपाली",
    "direction": "ltr"
  }, */,
  {
    wdQid: 'Q7411',
    wikimediaCode: 'nl',
    i18nCode: 'nl',
    labelEN: 'Dutch',
    labelNative: 'Nederlands',
    direction: 'ltr',
  },
  {
    wdQid: 'Q14185',
    wikimediaCode: 'oc',
    i18nCode: 'oc',
    labelEN: 'Occitan',
    labelNative: 'Occitan',
    direction: 'ltr',
  } /*
  {
    "wdQid": "Q33810",
    "wikimediaCode": "or",
    "i18nCode": "or",
    "labelEN": "Odia",
    "labelNative": "ଓଡ଼ିଆ",
    "direction": "ltr"
  },
  {
    "wdQid": "Q809",
    "wikimediaCode": "pl",
    "i18nCode": "pl",
    "labelEN": "Polish",
    "labelNative": "Polski",
    "direction": "ltr"
  }, */,
  {
    wdQid: 'Q58680',
    wikimediaCode: 'ps',
    i18nCode: 'ps',
    labelEN: 'Pashto',
    labelNative: 'پښتو',
    direction: 'rtl',
  },
  {
    wdQid: 'Q5146',
    wikimediaCode: 'pt',
    i18nCode: 'pt',
    labelEN: 'Portuguese',
    labelNative: 'Português',
    direction: 'ltr',
  } /*
  {
    "wdQid": "Q5146",
    "wikimediaCode": "pt",
    "i18nCode": "pt-br",
    "labelEN": "Portuguese",
    "labelNative": "Português (brasil)",
    "direction": "ltr"
  }, */,
  {
    wdQid: 'Q5218',
    wikimediaCode: 'qu',
    i18nCode: 'qu',
    labelEN: 'Quechua',
    labelNative: 'Qhichwa simi',
    direction: 'ltr',
  },
  {
    wdQid: 'Q7737',
    wikimediaCode: 'ru',
    i18nCode: 'ru',
    labelEN: 'Russian',
    labelNative: 'Русский',
    direction: 'ltr',
  },
  {
    wdQid: 'Q7838',
    wikimediaCode: 'sw',
    i18nCode: 'sw',
    labelEN: 'Swahili',
    labelNative: 'Kiswahili',
    direction: 'ltr',
  } /*
  {
    "wdQid": "Q9027",
    "wikimediaCode": "sv",
    "i18nCode": "sv",
    "labelEN": "Swedish",
    "labelNative": "Svenska",
    "direction": "ltr"
  },
  {
    "wdQid": "Q9217",
    "wikimediaCode": "th",
    "i18nCode": "th",
    "labelEN": "Thai",
    "labelNative": "ภาษาไทย",
    "direction": "ltr"
  }, */,
  {
    wdQid: 'Q9260',
    wikimediaCode: 'tg',
    i18nCode: 'tg-cyrl',
    labelEN: 'Tajik',
    labelNative: 'забони тоҷикӣ',
    direction: 'ltr',
  } /*
  {
    "wdQid": "Q36846",
    "wikimediaCode": "tok",
    "i18nCode": "tok",
    "labelEN": "Toki Pona",
    "labelNative": "Toki Pona",
    "direction": "ltr"
  }, */,
  {
    wdQid: 'Q256',
    wikimediaCode: 'tr',
    i18nCode: 'tr',
    labelEN: 'Turkish',
    labelNative: 'Türkçe',
    direction: 'ltr',
  } /*
  {
    "wdQid": "Q8798",
    "wikimediaCode": "uk",
    "i18nCode": "uk",
    "labelEN": "Ukrainian",
    "labelNative": "Українська",
    "direction": "ltr"
  },
  {
    "wdQid": "Q9199",
    "wikimediaCode": "vi",
    "i18nCode": "vi",
    "labelEN": "Vietnamese",
    "labelNative": "Tiếng Việt",
    "direction": "ltr"
  },
  {
    "wdQid": "Q7033959",
    "wikimediaCode": "zh",
    "i18nCode": "yue-hant",
    "labelEN": "Yue Chinese",
    "labelNative": "粤语",
    "direction": "ltr"
  }, */,
  {
    wdQid: 'Q7850',
    wikimediaCode: 'zh',
    i18nCode: 'zh-hant',
    labelEN: 'Chinese',
    labelNative: '中文繁體',
    direction: 'ltr',
  },
  {
    wdQid: 'Q7850',
    wikimediaCode: 'zh',
    i18nCode: 'zh-hans',
    labelEN: 'Chinese Simplified',
    labelNative: '中文简体',
    direction: 'ltr',
  },
]
